export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-grid">
                    <div className="footer-brand">
                        <img
                            src="/images/rajbharti-logo.png"
                            alt="Rajbharti Quartzite Industries"
                            className="footer-logo"
                        />
                    </div>
                    <div>
                        <h4>Contact Us</h4>
                        <p className="email-line">
                            <span className="email-label">Email:</span>
                            <span className="email-values">
                                info.rqi@rajbhartifoods.com<br />
                                rajbhartiquartzite@gmail.com
                            </span>
                        </p>
                        <p>Phone: +91 9685818828</p>
                    </div>
                    <div>
                        <h4>Address</h4>
                        <p>
                            Near Nabagarh Gate, Main Road,<br />
                            Ajnaur Khas, Tikamgarh,<br />
                            Madhya Pradesh – 472010
                        </p>
                    </div>

                    <div>
                        <h4>Our Promise</h4>
                        <p>✓ Hygienic Processing</p>
                        <p>✓ Premium Packaging</p>
                        <p>✓ Organic Range (Upcoming)</p>

                    </div>
                </div>


                <div className="footer-bottom">
                    © 2026 Gulmohar Pulses | Rajbharti Quartzite Industries Pvt. Ltd
                    <span style={{ fontFamily: "cursive" }}>
                        {" "}Powered by{" "}
                        <a
                            href="https://ralithontechnologies.in"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-powered-link"
                        >
                            Ralithon Technologies
                        </a>
                    </span>
                </div>

            </div>
        </footer>
    );
}
